import React from 'react';
import { OnboardingFormData } from '..';

interface CommunityStepProps {
  formData: OnboardingFormData;
  updateFormData: (data: Partial<OnboardingFormData>) => void;
  onNext: () => void;
  onSkip: () => void;
  isLoading?: boolean;
}

const CommunityStep: React.FC<CommunityStepProps> = () => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-6 space-y-6 bg-[#FBF6F1]">
      {/* Title */}
      <div className="text-center">
        <h1 className="text-2xl font-semibold font-inter text-midnight-blue leading-7">
          Xem ai đang ở gần bạn
        </h1>
      </div>

      {/* Image Slider */}
      <div className="w-full max-w-sm">
        <img className="w-full h-56 object-cover rounded-lg" src="/images/neiborhood.png" />
        <div className="py-2 flex justify-center items-center gap-2">
          <div className="w-6 h-2 bg-[#6F6F6B] rounded-[20px]" />
          <div className="size-2 bg-zinc-300 rounded-full" />
          <div className="size-2 bg-zinc-300 rounded-full" />
        </div>
      </div>

      {/* Content */}
      <div className="text-center space-y-4">
        <h2 className="text-xl font-semibold font-inter text-burnt-orange leading-normal">
          Tổ chức tiệc khu phố dễ dàng
        </h2>
        <p className="text-sm font-normal font-inter text-midnight-blue leading-tight">
          Tạo sự kiện và kết nối với cộng đồng <br/>lân cận của bạn
        </p>
      </div>

      {/* Laptop Illustration - Hidden for now */}
      <div className=" flex flex-col justify-center items-center gap-2">
        <img src="/icons/laptop-illustration.svg" alt="Laptop" className="w-34 h-34" />
      </div>

      {/* Footer Note */}
      <div className="text-center max-w-sm">
        <p className="text-xs font-normal font-inter text-midnight-blue/60 leading-none">
          Danh bạ được lưu trữ an toàn. Cập nhật đồng bộ danh bạ bất kì lúc nào trong cài đặt riêng tư
        </p>
      </div>
    </div>
  );
};

export default CommunityStep;